import * as React from 'react';
import { ViewMedium, Viewport } from '@shared-ui/viewport-context';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkView, UitkViewRow } from 'uitk-react-view';
export var ActivityDetailsViewTemplate = function (_a) {
  var afterHeaderNotification = _a.afterHeaderNotification,
    imageGallery = _a.imageGallery,
    backToSearch = _a.backToSearch,
    discountBanner = _a.discountBanner,
    footer = _a.footer,
    offers = _a.offers,
    overview = _a.overview,
    recommendations = _a.recommendations,
    reviews = _a.reviews,
    sideRailAd = _a.sideRailAd,
    footerAd = _a.footerAd,
    shareFeedback = _a.shareFeedback,
    staticDetails = _a.staticDetails,
    tabNavigatorMiddle = _a.tabNavigatorMiddle,
    tabNavigatorTop = _a.tabNavigatorTop,
    partnerDetails = _a.partnerDetails,
    legalDisclaimer = _a.legalDisclaimer,
    localisationDisclaimer = _a.localisationDisclaimer,
    oneKeyBanner = _a.oneKeyBanner,
    oneKeyMessageCard = _a.oneKeyMessageCard,
    directFeedback = _a.directFeedback,
    partnerMemberMessageCards = _a.partnerMemberMessageCards;
  return React.createElement("div", {
    "data-testid": "infosite-page-view"
  }, React.createElement(UitkView, null, React.createElement(UitkViewRow, {
    layout: "fullwidth",
    adSlot: false,
    canvasTheme: "secondary"
  }, React.createElement(UitkLayoutGrid, null, React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, afterHeaderNotification ? React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, React.createElement("section", {
    "data-testid": "details-view--afterHeaderNotification"
  }, afterHeaderNotification)) : null))), React.createElement(UitkViewRow, {
    layout: "centered",
    adSlot: true,
    canvasTheme: "secondary"
  }, React.createElement(UitkLayoutGrid, {
    columns: {
      small: 1,
      medium: 8,
      large: 12
    },
    alignContent: "start"
  }, oneKeyMessageCard && React.createElement(Viewport, null, React.createElement(ViewMedium, null, React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--one-key-message-banner"
  }, oneKeyMessageCard)))), React.createElement(UitkSpacing, {
    padding: "two"
  }, React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, backToSearch)), imageGallery ? React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, React.createElement("section", {
    "data-testid": "details-view--image-gallery"
  }, imageGallery)) : null, tabNavigatorTop ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--tabNavigatorTop"
  }, tabNavigatorTop)) : null, React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--overview"
  }, overview)), discountBanner ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--discountBanner"
  }, discountBanner)) : null, oneKeyBanner && React.createElement(Viewport, null, React.createElement(ViewMedium, null, React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--one-key-top-banner"
  }, oneKeyBanner)))), React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--partner-member-message-card"
  }, partnerMemberMessageCards)), offers ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--offers"
  }, offers)) : null, localisationDisclaimer ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--localisation-disclaimer"
  }, localisationDisclaimer)) : null, tabNavigatorMiddle ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--tabNavigatorMiddle"
  }, tabNavigatorMiddle)) : null, React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--staticDetails"
  }, staticDetails)), recommendations ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--recommendations"
  }, recommendations)) : null, reviews ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--reviews"
  }, reviews)) : null, legalDisclaimer ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--disclaimer"
  }, legalDisclaimer)) : null, partnerDetails ? React.createElement(UitkLayoutGridItem, {
    colSpan: {
      small: 1,
      medium: 8,
      large: 12
    }
  }, React.createElement("section", {
    "data-testid": "details-view--partnerDetails"
  }, partnerDetails)) : null), sideRailAd || null), React.createElement(UitkViewRow, {
    layout: "centered",
    adSlot: true,
    canvasTheme: "secondary"
  }, React.createElement(UitkLayoutGrid, null, React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, React.createElement("section", {
    "data-testid": "details-view--footer-ad"
  }, footerAd)))), React.createElement(UitkViewRow, {
    layout: "centered",
    canvasTheme: "secondary"
  }, React.createElement("section", {
    "data-testid": "details-view-direct-feedback-cta"
  }, directFeedback)), React.createElement(UitkViewRow, {
    canvasTheme: "secondary"
  }, React.createElement("section", null, shareFeedback)), React.createElement(UitkViewRow, {
    layout: "centered",
    adSlot: true
  }, React.createElement(UitkLayoutGrid, null, React.createElement(UitkLayoutGridItem, {
    colSpan: "all"
  }, React.createElement("section", {
    "data-testid": "details-view--footer"
  }, footer))))));
};